/* esm.sh - bail@2.0.2 */
export * from "/*bail@2.0.2/esnext/bail.mjs";
